import axios from "axios";
import { getItem } from "../utils";

// const domain = window.location.href.split('/');
// const subdomain = domain[2].split('.')[0];

// const baseURL =
//   subdomain === 'atlas'
//     ? 'https://auth.hml.externals-atlas.com'
//     : 'https://auth.prd.externals-atlas.com';

const atlas = axios.create({
  baseURL: 'https://auth.prd.api.p4adm.com',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

atlas.interceptors.request.use(
  async (request) => {
    const PROJECT = await getItem("tk-project");

    const USER = await getItem("tk-user");
    const COMPANY = await getItem("companyId");
    request.headers["tk-project"] = PROJECT;

    if (PROJECT && USER) {
      request.headers["tk-project"] = PROJECT;
      request.headers["tk-user"] = USER;
    }

    // if (
    //   (PROJECT &&
    //     [
    //       'full-auth/tkUserIB',
    //       'full-auth/recoveryPassword',
    //       'full-auth/changePassword',
    //       'full-auth/validateTokenIB',
    //       '/onboarding/account/create',
    //       '/uploads/documents/accounts',
    //     ].includes(request.url)) ||
    //   request.url.match(/requestToken/) ||
    //   request.url.match(/deposit/) ||
    //   request.url.match(/checkUser/) ||
    //   request.url.substr(0, 15) === '/validateToken/'
    // ) {
    //   request.headers['tk-project'] = PROJECT;
    // }

    request.headers["company"] = COMPANY ? COMPANY : "";

    return request;
  },
  function (error) {
    return Promise.reject(error);
  }
);

atlas.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default atlas;
